import Vue from 'vue'
import Router from 'vue-router'

// 登录页
const Login = () => import('./views/Login.vue')
const Layout = () => import('./views/Layout.vue')
// 控制台
const GlobalSettings = () => import('./views/globalSettings/index.vue')
const Console = () => import('./views/globalSettings/Console.vue')
// 用户名片列表
const User = () => import('./views/user/index.vue')
const Users = () => import('./views/user/Users.vue')
const Card = () => import('./views/user/Card.vue')
const EducationTraining = () => import('./views/user/EducationTraining.vue')
const WorkExperience = () => import('./views/user/WorkExperience.vue')
// 名片配置管理
const CardConfig = () => import('./views/cardConfig/index.vue')
const CardTheme = () => import('./views/cardConfig/CardTheme.vue')
const InfoHint = () => import('./views/cardConfig/InfoHint.vue')
// 权限管理
const Auth = () => import('./views/auth/index.vue')
const Adminers = () => import('./views/auth/adminers.vue')
const Groups = () => import('./views/auth/groups.vue')
const Rules = () => import('./views/auth/rules.vue')

Vue.use(Router)
const router = new Router({
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login, hidden: true },
    {
      path: '/layout',
      redirect: '/console',
      component: Layout,
      children: [{
          path: '/globalSettings',
          name: 'globalSettings',
          redirect: '/console',
          component: GlobalSettings,
          meta: { title: '全局设置', },
          children: [{
            path: '/console',
            name: 'console',
            component: Console,
            meta: { title: '控制台', },
          }, ]
        },
        {
          path: '/user',
          name: 'user',
          redirect: '/users',
          component: User,
          meta: { title: '用户名片列表', },
          children: [{
              path: '/users',
              name: 'users',
              component: Users,
              meta: { title: '用户列表' },
            },
            {
              path: '/card',
              name: 'card',
              component: Card,
              meta: { title: '名片列表' },
            },
            {
              path: '/educationTraining',
              name: 'educationTraining',
              component: EducationTraining,
              meta: { title: '教育培训列表' },
            },
            {
              path: '/workExperience',
              name: 'workExperience',
              component: WorkExperience,
              meta: { title: '工作经历列表' },
            },
          ]
        },
        {
          path: '/cardConfig',
          name: 'cardConfig',
          redirect: '/cardTheme',
          component: CardConfig,
          meta: { title: '名片配置管理' },
          children: [{
              path: '/cardTheme',
              name: 'cardTheme',
              component: CardTheme,
              meta: { title: '名片主题' },
            },
            {
              path: '/infoHint',
              name: 'infoHint',
              component: InfoHint,
              meta: { title: '消息提示' },
            },
          ]
        },

        {
          path: '/auth',
          name: 'auth',
          redirect: '/adminers',
          component: Auth,
          meta: { title: '权限管理' },
          children: [{
              path: '/adminers',
              name: 'adminers',
              component: Adminers,
              meta: { title: '管理员列表' },
            },
            {
              path: '/groups',
              name: 'groups',
              component: Groups,
              meta: { title: '部门分组列表' },
            },
            {
              path: '/rules',
              name: 'rules',
              component: Rules,
              meta: { title: '权限列表' },
            },
          ]
        },

      ]
    },
  ]
})

// 挂载路由导航守卫
// router.beforeEach((to, from, next) => {
//   // to 将要访问的路径
//   // from 代表从哪个路径跳转而来
//   // next 是一个函数，表示放行
//   //     next()  放行    next('/login')  强制跳转
//
//   if (to.path === '/login') return next()
//   // 获取token
//   const tokenStr = window.sessionStorage.getItem('token')
//   if (!tokenStr) return next('/login')
//   next()
// })

export default router
